import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, flatMap } from 'rxjs/operators';
import { StreamService } from '../services/stream.service';

@Component({
    template: `
        <topic-summary-grid [topics]="topics" 
                            linkPath="../categories/uncategorized/" 
                            emptyMessage="No topics found that match your search term">
        </topic-summary-grid>
    `
})
export class BrowseSearchPane implements OnDestroy {
    cleanupTime = new Subject<void>();
    topics: any[];

    constructor(route: ActivatedRoute, streamService: StreamService) {        
        route.queryParams.pipe(
            flatMap(params => streamService.getTenantStreams({ 
                term: params.term,
                page: 0,
                rows: 500, 
                includeCatalogs: true, 
                published: true 
            })),
            takeUntil(this.cleanupTime)
        ).subscribe(results => this.topics = results.content);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
